export default __webpack_public_path__ + "static/media/geojson-mode.e4cd0fbe.svg";